import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@core/services/api/apiRequest";
import { normalizeQuizResponseData } from "../utils/normalizeQuizResponseData";
import type { QuizResponse } from "../quiz.types";

export type UseFetchQuizResponseArgs = {
  quizId: number;
};

export type UseFetchQuizResponseResult = {
  quizResponse: QuizResponse;
  quiz: QuizResponse;
};

/**
 * Hook to get or create a quiz response for the authenticated user.
 * Takes a quiz ID and returns the quiz response (creating one if needed).
 * Normalizes the response data to include question sets.
 */
export function useFetchQuizResponse({ quizId }: UseFetchQuizResponseArgs) {
  const query = useQuery({
    queryKey: ["quiz-response", quizId],
    queryFn: async () => apiRequest(`/quiz/response/${quizId}/`, "GET"),
    enabled: !!quizId,
    select: (data): UseFetchQuizResponseResult => {
      return {
        quizResponse: data.quiz_response,
        quiz: normalizeQuizResponseData(data.quiz),
      };
    },
  });

  return query;
}
